export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Управление изменениями — обучение руководителей и команд",
        "description": "Управление изменениями в компании: как внедрять новые процессы, технологии и правила, работать с сопротивлением сотрудников и помогать команде адаптироваться. Практическое корпоративное обучение.",
        "url": "https://business-training.by/menedzhment-i-liderstvo/upravlenie-izmeneniyami",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Service",
        "name": "Обучение управлению изменениями",
        "description": "Корпоративное обучение руководителей и управленческих команд управлению изменениями: внедрение новых процессов, стандартов и инструментов, работа с сопротивлением сотрудников, коммуникация изменений и закрепление нового поведения в ежедневной практике.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "обучение управлению изменениями, управление изменениями в компании, внедрение изменений, работа с сопротивлением сотрудников, развитие управленческих компетенций",
        "url": "https://business-training.by/menedzhment-i-liderstvo/upravlenie-izmeneniyami"
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что такое управление изменениями в компании?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Это управленческая работа по переводу компании от старого способа работы к новому: объяснение причин изменений, обучение сотрудников, работа с сопротивлением, поддержка в переходный период и закрепление нового поведения в процессах, стандартах и контроле. Изменения становятся результатом не тогда, когда о них объявили, а когда новое поведение стало частью ежедневной работы."
            }
          },
          {
            "@type": "Question",
            "name": "Почему сотрудники сопротивляются изменениям?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Причины могут быть разными: сотрудник не понимает, зачем нужны изменения, не видит личной выгоды, боится потерять статус, не уверен, что справится, привык к старой системе или не доверяет руководству. Сопротивление не всегда означает саботаж — его нужно понимать и правильно с ним работать, а не просто преодолевать."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю работать с сопротивлением сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Сначала выявить причину сопротивления и отделить факты от эмоций. Затем объяснить необходимость изменений, дать возможность задать вопросы, обучить, дать безопасную практику, получить обратную связь и закрепить новое поведение в процессах и стандартах. Сопротивление — это сигнал, а не повод для давления."
            }
          },
          {
            "@type": "Question",
            "name": "Как внедрить новые процессы в компании?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Недостаточно объявить о новом процессе — нужно пройти путь от решения к новому стандарту: объяснить причины, убедиться, что сотрудники поняли и приняли изменения, обучить необходимым навыкам, дать практику, поддерживать в переходный период, контролировать качество внедрения и закрепить новое поведение в стандартах."
            }
          },
          {
            "@type": "Question",
            "name": "Как подготовить сотрудников к изменениям?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Объяснить, что меняется и почему, сформировать понятные ожидания, выслушать опасения, дать необходимые знания и навыки и позволить безопасно попробовать новый способ работы. Чем лучше сотрудники понимают изменения и чувствуют поддержку, тем меньше сопротивление и быстрее адаптация."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю правильно сообщить команде об изменениях?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Честно и своевременно: объяснить причины и последствия, не создавать ложных ожиданий, отвечать на неудобные вопросы, говорить о неприятных последствиях прямо и вовлекать руководителей среднего звена в донесение информации. Чем меньше информации сотрудники получают от руководства, тем больше домыслов они создают сами."
            }
          },
          {
            "@type": "Question",
            "name": "Как снизить сопротивление изменениям?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Через понимание, вовлечение и поддержку: объяснить необходимость, дать сотрудникам возможность высказать опасения и задать вопросы, обучить новым навыкам, дать практику и закрепить новое поведение. Сопротивление снижается, когда люди понимают изменения и чувствуют, что их не оставили один на один с неопределённостью."
            }
          },
          {
            "@type": "Question",
            "name": "Какие навыки нужны руководителю для управления изменениями?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Коммуникация, лидерство, эмоциональный интеллект, переговоры, работа с конфликтами, постановка задач, контроль и обратная связь, а также мотивация. Руководитель должен уметь объяснять изменения, вести команду через неопределённость и переводить изменения в конкретные действия и закреплённые стандарты."
            }
          },
          {
            "@type": "Question",
            "name": "Подходит ли обучение для новых руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да. Новым руководителям важно освоить инструменты управления изменениями вместе с новой управленческой ролью: как объяснять решения, работать с сопротивлением команды и закреплять новые правила работы. Программа адаптируется под уровень участников."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли адаптировать программу под конкретную компанию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация — обязательный этап. Сначала мы разбираемся, какие изменения происходят в компании и где возникают основные сложности, затем настраиваем программу под специфику бизнеса, уровень руководителей и характер изменений."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли проводить обучение онлайн?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, обучение проводится как очно в Минске и Беларуси, так и онлайн. Формат подбирается под задачу компании: корпоративный тренинг, модульная программа, бизнес-игры, коучинг руководителей или сопровождение во время внедрения изменений."
            }
          },
          {
            "@type": "Question",
            "name": "Что происходит после тренинга?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обучение не заканчивается тренингом. Руководители переносят инструменты в реальную работу, а при необходимости проводится сопровождение: разбираются возникающие сложности, корректируются действия и оцениваются изменения в управленческом поведении и процессах."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли добавить сопровождение после обучения?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да. Сопровождение помогает закрепить результаты: разбираем реальные ситуации внедрения изменений, поддерживаем руководителей в сложных разговорах и определяем, какие изменения произошли в управленческом поведении и процессах."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}